import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FiArrowLeft, FiDroplet, FiSun, FiShield, FiAlertTriangle, FiX } from 'react-icons/fi';
import { authAPI } from "../../services/api";



export default function ProductCare() {
  const { productId } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedDisease, setSelectedDisease] = useState(null);

  useEffect(() => {
    const fetchCareData = async () => {
      try {
        setLoading(true);
        const result = await authAPI.getProduceCare(productId);
        
        if (result.status) {
          const data = result.data;
          const formattedProduct = {
            id: productId,
            name: data.produce_name,
            image: data.image,
            careInstructions: data.care_instructions?.[0] || {},
            careRecommendations: data.care_recommendations || [],
            diseases: data.diseases || []
          };
          
          setProduct(formattedProduct);
        }
      } catch (error) {
        console.error('Error fetching care data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (productId) {
      fetchCareData();
    }
  }, [productId]);

  if (loading) {
    return (
      <div className="product-care-loading-ap">
        <h2>Loading care information...</h2>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="product-care-not-found-ap">
        <h2>Product Care Information Not Available</h2>
        <Link to="/dashboard" className="back-link-ap">
          <FiArrowLeft /> Return to Dashboard
        </Link>
      </div>
    );
  }

  return (
    <div className="product-care-container-ap">
      <div className="product-care-header-ap">
        <Link to={`/farmer-dashboard/produce/${productId}`} className="back-btn-ap">
          <FiArrowLeft /> Back to Produce
        </Link>
        <div className="product-title-ap">
          <img 
            src={product.image} 
            alt={product.name}
            className="product-image-ap"
          />
          <h1>{product.name} Care Guide</h1>
        </div>
      </div>

      <div className="health-summary-ap">
  
        <div className="care-requirements-ap">
          <div className="requirement-card-ap">
            <div className="requirement-icon-container-ap">
              <FiDroplet className="requirement-icon-ap" />
            </div>
            <div>
              <h3>Water</h3>
              <p>{product.careInstructions.watering_schedule || "Not specified"}</p>
            </div>
          </div>
          <div className="requirement-card-ap">
            <div className="requirement-icon-container-ap">
              <FiSun className="requirement-icon-ap" />
            </div>
            <div>
              <h3>Sunlight</h3>
              <p>{product.careInstructions.sunlight_frequency || "Not specified"}</p>
            </div>
          </div>
          <div className="requirement-card-ap">
            <div className="requirement-icon-container-ap">
              <FiShield className="requirement-icon-ap" />
            </div>
            <div>
              <h3>Fertilizing</h3>
              <p>{product.careInstructions.fertilizing_frequency || "Not specified"}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="disease-section-ap">
        <h2 className="section-title-ap">
          <FiAlertTriangle className="section-icon-ap" />
          Potential Diseases
        </h2>
        {product.diseases.length > 0 ? (
          <div className="disease-grid-ap">
            {product.diseases.map((disease, index) => (
              <div 
                key={index} 
                className="disease-thumbnail-ap"
                onClick={() => setSelectedDisease(disease)}
              >
                <img 
                  src={disease.images || "https://via.placeholder.com/150x150?text=No+Image"} 
                  alt={disease.disease_name} 
                  className="disease-image-ap" 
                />
                <div className="disease-name-ap">{disease.disease_name}</div>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-diseases-ap">
            <p>No diseases recorded for this produce.</p>
          </div>
        )}
      </div>

      <div className="care-tips-section-ap">
        <h2 className="section-title-ap">
          <FiSun className="section-icon-ap" />
          Care Recommendations
        </h2>
        {product.careRecommendations.length > 0 ? (
          <ul className="tips-list-ap">
            {product.careRecommendations.map((recommendation, index) => (
              <li key={index} className="tip-item-ap">
                <span className="tip-number-ap">{index + 1}</span>
                <span>{recommendation.recommendations}</span>
              </li>
            ))}
          </ul>
        ) : (
          <div className="no-recommendations-ap">
            <p>No care recommendations available.</p>
          </div>
        )}
      </div>

      {/* Disease Detail Modal */}
      {selectedDisease && (
        <div className="disease-modal-overlay-ap">
          <div className="disease-modal-ap">
            <button 
              className="close-modal-btn-ap"
              onClick={() => setSelectedDisease(null)}
            >
              <FiX />
            </button>
            
            <div className="modal-header-ap">
              <h2>{selectedDisease.disease_name}</h2>
              <img 
                src={selectedDisease.images || "https://via.placeholder.com/300x200?text=No+Image"} 
                alt={selectedDisease.disease_name} 
                className="modal-disease-image-ap"
              />
            </div>
            
            <div className="modal-content-ap">
              <p className="disease-description-ap">{selectedDisease.full_disease_description}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}